import { ReactNode } from 'react';
import { ConfirmPopup as PrimePopup } from 'primereact/confirmpopup';
import { PopupConfig } from '../types';

interface SimplePopupProps {
    config: PopupConfig | null;
    visible: boolean;
    onHide: () => void;
}

export function SimplePopup({
    config,
    visible,
    onHide,
}: SimplePopupProps): ReactNode {
    return (
        <PrimePopup
            visible={visible}
            target={config?.target}
            className={config?.className}
            message={config?.content ?? <></>}
            footer={config?.footer ?? <></>}
            onHide={onHide}
        />
    );
}
